// src/parts/Footer.jsx
import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-4 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-center text-gray-400">
          &copy; {new Date().getFullYear()} Honex Food Center. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
